import {ref} from 'vue';
import {defineStore, storeToRefs} from 'pinia';
import {Configuration, WebPreferencesApi, type ProfileWebPreferences} from '@api';
import {useProfileStore} from './profileStore';

export const useWebPreferencesStore = defineStore('web-preferences', () => {
    const apiConfiguration = new Configuration({basePath: ''});
    const webPreferencesApi = new WebPreferencesApi(apiConfiguration);

    const {profile} = storeToRefs(useProfileStore());

    // Exposed refs a-z
    const webPreferences = ref<ProfileWebPreferences>();

    // Exposed functions a-z
    async function acknowledgeOnboarding(): Promise<void> {
        await webPreferencesApi.acknowledgeProfileOnboarding();
    }

    async function acknowledgeProfileProductTour(): Promise<void> {
        await webPreferencesApi.acknowledgeProfileProductTour();
    }

    async function acknowledgePortfolioShareProductTour(): Promise<void> {
        await webPreferencesApi.acknowledgePortfolioShareProductTour();
        if (webPreferences.value) {
            webPreferences.value.portfolioShareProductTourAcknowledged = true;
        }
    }

    async function acknowledgePortfolioEditorProductTour(): Promise<void> {
        await webPreferencesApi.acknowledgePortfolioEditorProductTour();
        if (webPreferences.value) {
            webPreferences.value.portfolioEditorProductTourAcknowledged = true;
        }
    }

    async function adminAcknowledgeOnboarding(acknowledge: boolean): Promise<void> {
        await webPreferencesApi.adminAcknowledgeOnboarding({
            profileId: profile.value!.profileId,
            adminOnboardingAcknowledgmentRequest: {value: acknowledge},
        });
    }

    async function getWebPreferences(accountId: string): Promise<ProfileWebPreferences | undefined> {
        webPreferences.value = await webPreferencesApi.getWebPreferences({accountId});

        return webPreferences.value;
    }

    return {
        // refs a-z
        webPreferences,
        // functions a-z
        acknowledgeOnboarding,
        acknowledgePortfolioEditorProductTour,
        acknowledgePortfolioShareProductTour,
        acknowledgeProfileProductTour,
        adminAcknowledgeOnboarding,
        getWebPreferences,
    };
});
